import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { VoyagePartComponent } from '../voyage-part-component';
import { OrganisationService } from 'src/app/organisation/organisation.service';
import { Organisation } from 'src/app/generated/services/organisations/organisation';
import { DateTimeHelpers } from '../../../../shared/helpers/date-time.helpers';
import { KeycloakService} from 'src/app/authentication/keycloak.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { MaterialDateRangeComponent, DateRange } from 'src/app/shared/components/material-date-picker/material-date-range.component';
import { MaterialOrganisationSelectorComponent } from 'src/app/shared/components/material-autocomplete/material-organisationselector.component';
import { MatSelectModule } from '@angular/material/select';
import { Nor, Voyage } from 'src/app/generated/services/transportation/voyages/voyage';
import { MaterialPgButtonComponent } from 'src/app/shared/components/material-pg-button/material-pg-button.component';
import { MaterialPdfViewerComponent } from 'src/app/shared/components/material-pdf-viewer/material-pdf-viewer.component';
import { MaterialChunkFileUploadComponent } from 'src/app/shared/components/material-file-uploader/material-chunk-file-upload.component';
import { DocumentReference } from 'src/app/documents/documents.service';
import { VoyageServiceSpa } from 'src/app/generated/services/transportation/voyages/voyageSpa';
import { PgMessagesService, MessageLevel } from 'src/app/shared/services/pg-messages.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { forkJoin } from 'rxjs';
// import {VoyageToolbarComponent} from './voyage-toolbar/voyage-toolbar.component';
import {
  PgSubTitleComponent,
  PgTitleComponent,
} from 'src/app/shared/components/title-bar/title-bar.component';
import { MaterialAutoCompleteComponent } from 'src/app/shared/components/material-autocomplete/material-auto-complete.component';
@Component({
  selector: 'app-nor',
  templateUrl: './nor.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    SharedModule,
    MaterialDateRangeComponent,
    MaterialOrganisationSelectorComponent,
    MatSelectModule,
    MaterialPgButtonComponent,
    MaterialPdfViewerComponent,
    MaterialChunkFileUploadComponent,
    MaterialAutoCompleteComponent,
  ]
})
export class NorComponent implements OnInit, VoyagePartComponent, PgSubTitleComponent,
  PgTitleComponent {

  @Output() changed: EventEmitter<Voyage> = new EventEmitter();
  @Output() cancelled: EventEmitter<any> = new EventEmitter();

  key = 'NOR';

  subTitle: EventEmitter<string> = new EventEmitter();
  title: EventEmitter<string> = new EventEmitter();
  _uploadedFileId!: string;
  _newUploadedFileId!: string;
  _selectedVoyage = Voyage.create();
  _selectedNor!: Nor;
  _selectedDate: DateRange = {
    startDate: new Date(),
    endDate: new Date()
  };
  expectedVersion?: number;
  dateSelection = false;
  edit = false;

  portOrganisations: Organisation[] = [];
  port: Organisation | undefined;
  doc?: DocumentReference;

  @Input() set fileId(value: string) {
    this._uploadedFileId = value;
  }

  @Input() set updatedFileId(value: string) {
    this._newUploadedFileId = value;
  }
  @Input() set data(value: any) {
    this._selectedVoyage = value as Voyage;
  }
  selectedNorTypes = ['loading', 'discharging'];
  constructor(private _organisationsService: OrganisationService,
              private _keycloakService: KeycloakService,
              private _voyagesService: VoyageServiceSpa,
              private _pgMessagesService: PgMessagesService,
              private _router: Router,
              private _activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this._activatedRoute.paramMap.subscribe(p => {
      this._activatedRoute.queryParams.subscribe(p => {
        this._uploadedFileId = p['fileId'];
      });

      forkJoin([
        this._voyagesService.getVoyageById({
          id: p.get('id') || ''
        }),
        this._organisationsService.getPorts()
      ]).subscribe(results => {
        this._selectedVoyage = results[0].data || Voyage.create();
        this.expectedVersion = results[0].version;
        this._selectedNor = this._selectedVoyage.nors.find(
          nor => nor.fileId === this._uploadedFileId
        )!;
        if (this._selectedNor) {
          this.edit = true;
        } else {
          this._selectedNor = Nor.create();
        }

        this.portOrganisations = results[1];

        this.port = this.portOrganisations.find(
          p => p.name === this._selectedNor.portOrganisationId
        );

        if (this.port) {
          this._selectedDate = {
            startDate: new Date(
              DateTimeHelpers.getDateTimeFromTimestamp(
                this.port.timezone,
                this._selectedNor.timestamp)),
            endDate: new Date(
              DateTimeHelpers.getDateTimeFromTimestamp(
                this.port.timezone,
                this._selectedNor.timestamp))
          };
        }

      });
    });
  }

  hasRole(role: string) {
    return this._keycloakService.hasRole(role);
  }

  saveNor() {
    this._selectedNor.portOrganisationId = this.port?.name ?? '';
    this._selectedNor.timestamp = this._selectedDate.startDate.getTime();
    if (!this.edit) {
      if (this._selectedVoyage.nors) {
        this._selectedVoyage.nors.push(this._selectedNor);
      } else {
        this._selectedVoyage.nors = [this._selectedNor];
      }
      if (this.port && this.port.timezone) {
        this._selectedNor.timestamp = DateTimeHelpers.offsetTimestampWithZone(this._selectedNor.timestamp, this.port.timezone);
      }
    } else {
      console.error(`Timezone offset is missing for selected organisation Id: ${this._selectedNor.portOrganisationId}`);
    }
    this.updateVoyage(this._selectedVoyage);
  }
  updateVoyage(voyage: Voyage) {
    this._voyagesService.updateVoyage({data: voyage, expectedVersion: this.expectedVersion || 0}).then(() => {
      this._pgMessagesService.publishMessage({
        level: MessageLevel.Info,
        message: `Updated voyage ${voyage.shipVoyageNo} for ${voyage.vesselName}`,
        topic: 'Voyage'
      });
      this._router.navigate(['vessels/voyage', voyage.id], {
        queryParams: {
          t: new Date().getTime()
        }
      }).then();
    });
  }

  uploadDocument(docReference: DocumentReference) {
    this._selectedNor.fileId = docReference.id;
  }

  organisationValueFormatter(data: Organisation) {
    return data.nameTranslations['en'];
  }

  deleteNor() {
    if (confirm('Are you sure to delete this NOR')) {
      const i = this._selectedVoyage.nors.findIndex(n => n.fileId === this._selectedNor.fileId);
      this._selectedVoyage.nors.splice(i, 1);
      this.changed.emit(this._selectedVoyage);
    }
  }
  backToVoyage(){
    this._router.navigate(['/vessels/voyage/', this._selectedVoyage?.id,]);
  }
  norTypeFormatter(norType: string): string {
    return norType;
  }
}
